import React, {useEffect, useRef, useState} from 'react';
import BarGraph from "./BarGraph";
import useAxiosIntercept from "../../hooks/useAxiosIntercept";
import CustomerCharing from "./CustomerCharing";
import customerCharing from "./CustomerCharing";

function DashboardData(props) {
    const axiosPrivate = useAxiosIntercept();
    const effectRef = useRef(true);
    const [averageCharge, setAverageCharge] = useState('');
    const [averagePackagePrice, setAveragePackagePrice] = useState('');
    const [packages, setPackages] = useState([]);
    const [totalCustomer, setTotalCustomer] = useState(0);
    const [totalSales, setTotalSales] = useState(0);
    const [customerData, setCustomerData] = useState([]);
    const [salesData, setSalesData] = useState([]);
    const [labelData, setLabelData] = useState([]);
    const [salesLabelData, setSalesLabelData] = useState([]);
    const [selected, setSelected] = useState(12);
    const [selectedSale, setSelectedSale] = useState(12);
    const [openSelect, setOpenSelect] = useState(false);
    const [openSelectSale, setOpenSelectSale] = useState(false);
    const [percentSalesChange, setPercentSalesChange] = useState(0);
    const [percentCustomerChange, setPercentCustomerChange] = useState(0);
    const [chargingData, setChargingData] = useState([]);


    const getSalesData = async (fromDate, toDate) =>{
        try{
            let url =  process.env.REACT_APP_GET_SALES_DATA;
            let payload = {};
            if(fromDate && toDate){
                payload.from_date = fromDate;
                payload.to_date = toDate;
            }
            const response = await axiosPrivate.post(url, payload);
            if(response?.data?.response?.data){
                return response?.data?.response?.data;
            }
        }
        catch(err){
            console.log("something went wrong ", err)
        }
    }
    const getCustomerData = async (fromDate, toDate) =>{
        try{
            let url =  process.env.REACT_APP_GET_CUSTOMER_DATA;
            let payload = {};
            if(fromDate && toDate){
                payload.from_date = fromDate;
                payload.to_date = toDate;
            }
            const response = await axiosPrivate.post(url, payload);
            if(response?.data?.response?.data){
                return response?.data?.response?.data;
            }
        }
        catch(err){
            console.log("something went wrong ", err)
        }
    }
    const getAvgChargeAndSellingPrice = async () =>{
        try{
            let url =  process.env.REACT_APP_GET_CHARGE_PACKAGE;
            const response = await axiosPrivate.get(url);
            if(response?.data?.response?.data){
                return response?.data?.response?.data;
            }
        }
        catch (err){
            console.log("something went wrong",err);
        }
    }

    const getTopSellingPackages = async () =>{
        try{
            let url =  process.env.REACT_APP_TOP_SELLING_PACKAGE;
            let payload = {};
            payload.type = "M";
            const response = await axiosPrivate.post(url);
            if(response?.data?.response?.data){
                return response?.data?.response?.data;
            }
        }
        catch (err){
            console.log("something went wrong",err);
        }
    }
    const getChargingData = async () =>{
        try{
            let url =  process.env.REACT_APP_GET_CUSTOMER_CHARGE;
            const response = await axiosPrivate.post(url);
            if(response?.data?.response?.data){
                return response?.data?.response?.data;
            }
        }
        catch (err){
            console.log("something went wrong",err);
        }
    }


    useEffect(()=>{
        if (effectRef.current){
            effectRef.current = false;
            getChargingData().then((data)=>{
                if(data?.charge_by_location)
                    setChargingData(data?.charge_by_location);
            })

            getAvgChargeAndSellingPrice().then((data)=>{
                if(data?.average_charge)
                    setAverageCharge(data.average_charge);
                if(data?.average_package_price)
                    setAveragePackagePrice(data.average_package_price);
            });
            getTopSellingPackages().then((data)=>{
                if(data?.package_records)
                    setPackages(data.package_records);
            });
            let fromDate, toDate;
            const today = new Date();
            const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
            const lastDayOfPreviousMonth = new Date(firstDayOfMonth - 1);

            const year = lastDayOfPreviousMonth.getFullYear();
            const month = String(lastDayOfPreviousMonth.getMonth() + 1).padStart(2, '0');
            const day = String(lastDayOfPreviousMonth.getDate()).padStart(2, '0');
            const formattedDate = `${year}-${month}-${day}`;
            toDate= formattedDate;
            const firstDayOfPreviousMonth = new Date(firstDayOfMonth - 1);
            const firstDayOfThirdMonthBefore = new Date(firstDayOfPreviousMonth);
            firstDayOfThirdMonthBefore.setMonth(firstDayOfThirdMonthBefore.getMonth() - 11);
            firstDayOfThirdMonthBefore.setDate(1);
            fromDate = firstDayOfThirdMonthBefore.toISOString().slice(0, 10);

            getCustomerData(fromDate, toDate).then((data)=>{
                setCustomerData([]);
                setLabelData([]);
                if(data?.total_customers){
                    setTotalCustomer(data.total_customers);
                }
                if(data?.customer_data){

                    data.customer_data.forEach((item)=>{
                        setCustomerData(prevState => [...prevState, item.customers]);
                        setLabelData(prevState => [...prevState,item.month]);
                    })

                }
            });
            getSalesData(fromDate, toDate).then((data)=>{
                setSalesData([]);
                setSalesLabelData([]);
                if (data?.sales_added_monthly) {
                  
                    setPercentSalesChange(data?.sales_added_monthly);
                }
                if(data?.total_sales){
                    setTotalSales(data.total_sales);
                }
                if(data?.sales_data){

                    data.sales_data.forEach((item)=>{
                        setSalesData(prevState => [...prevState, item.sales_amount]);
                        setSalesLabelData(prevState => [...prevState,item.month]);
                    })

                }
            });
        }
    })
    const getDataForCustomer = (data) => {
        setCustomerData([]);
        setLabelData([]);

        let fromDate, toDate;
        const today = new Date();
        const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
        const lastDayOfPreviousMonth = new Date(firstDayOfMonth - 1);

        const year = lastDayOfPreviousMonth.getFullYear();
        const month = String(lastDayOfPreviousMonth.getMonth() + 1).padStart(2, '0');
        const day = String(lastDayOfPreviousMonth.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;
        toDate= formattedDate;

        const firstDayOfPreviousMonth = new Date(firstDayOfMonth - 1);
        const firstDayOfThirdMonthBefore = new Date(firstDayOfPreviousMonth);
        if(data == 0){
            fromDate = 0;
        }

        else if(data == 3){
            firstDayOfThirdMonthBefore.setMonth(firstDayOfThirdMonthBefore.getMonth() - 2);
            firstDayOfThirdMonthBefore.setDate(1);
            fromDate = firstDayOfThirdMonthBefore.toISOString().slice(0, 10);
        }
        else if(data == 6){
            firstDayOfThirdMonthBefore.setMonth(firstDayOfThirdMonthBefore.getMonth() - 5);
            firstDayOfThirdMonthBefore.setDate(1);
            fromDate = firstDayOfThirdMonthBefore.toISOString().slice(0, 10);

        }
        else if(data == 12){
            firstDayOfThirdMonthBefore.setMonth(firstDayOfThirdMonthBefore.getMonth() - 11);
            firstDayOfThirdMonthBefore.setDate(1);
            fromDate = firstDayOfThirdMonthBefore.toISOString().slice(0, 10);
        }

        getCustomerData(fromDate, toDate).then((data)=>{
            if(data?.total_customers){
                setTotalCustomer(data.total_customers);
            }
            if(data?.customers_added_monthly){
                setPercentCustomerChange(data?.customers_added_monthly);
            }
            if(data?.customer_data){
                data.customer_data.forEach((item)=>{
                    setCustomerData(prevState => [...prevState, item.customers]);
                    setLabelData(prevState => [...prevState,item.month]);
                })

            }
        });
    }

    const getDataForSales = (data) => {
      
        setSalesData([]);
        setSalesLabelData([]);

        let fromDate, toDate;
        const today = new Date();
        const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
        const lastDayOfPreviousMonth = new Date(firstDayOfMonth - 1);

        const year = lastDayOfPreviousMonth.getFullYear();
        const month = String(lastDayOfPreviousMonth.getMonth() + 1).padStart(2, '0');
        const day = String(lastDayOfPreviousMonth.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;
        toDate= formattedDate;

        const firstDayOfPreviousMonth = new Date(firstDayOfMonth - 1);
        const firstDayOfThirdMonthBefore = new Date(firstDayOfPreviousMonth);
        if(data == 0){
            fromDate = 0;
        }

        else if(data == 3){
            firstDayOfThirdMonthBefore.setMonth(firstDayOfThirdMonthBefore.getMonth() - 2);
            firstDayOfThirdMonthBefore.setDate(1);
            fromDate = firstDayOfThirdMonthBefore.toISOString().slice(0, 10);
        }
        else if(data == 6){
            firstDayOfThirdMonthBefore.setMonth(firstDayOfThirdMonthBefore.getMonth() - 5);
            firstDayOfThirdMonthBefore.setDate(1);
            fromDate = firstDayOfThirdMonthBefore.toISOString().slice(0, 10);

        }
        else if(data == 12){
            firstDayOfThirdMonthBefore.setMonth(firstDayOfThirdMonthBefore.getMonth() - 11);
            firstDayOfThirdMonthBefore.setDate(1);
            fromDate = firstDayOfThirdMonthBefore.toISOString().slice(0, 10);
        }

        getSalesData(fromDate, toDate).then((data) => {
        
            if (data?.total_sales) {
                setTotalSales(data.total_sales);
            }
          
            if (data?.sales_added_monthly != undefined ) {
              
                setPercentSalesChange(data?.sales_added_monthly);
            }
            if(data?.sales_data){
                data.sales_data.forEach((item)=>{
                    setSalesData(prevState => [...prevState, item.sales_amount]);
                    setSalesLabelData(prevState => [...prevState,item.month]);
                })

            }
        });
    }
    return (
        <div>
            <h2>Dashboard</h2>
            <div className="subContent">
                <div className="subContent">
                    <div className="xRow fullWidth lookUpDataDashboard mb-24">
                        <div className="boxT1 chargingData">
                            <i className="material-symbols-rounded grey fill">bolt</i>
                            <p>Average charge per user</p>
                            {averageCharge ?
                                <span>{averageCharge} kWh</span>
                                :
                                <span>0</span>
                            }
                        </div>
                        {/*<div className="boxT1">*/}
                        {/*    <i className="material-symbols-rounded grey fill">group</i>*/}
                        {/*    <p>Average drivers per account</p>*/}
                        {/*    <span>2</span>*/}
                        {/*</div>*/}
                        <div className="boxT1 packageData">
                            <i className="material-symbols-rounded grey fill">monetization_on</i>
                            <p>Average package price purchased</p>
                            {averagePackagePrice ?
                                <span>${averagePackagePrice}</span>
                                :
                                <span>0</span>
                            }
                        </div>
                    </div>
                    <div className="xRow pDashboard">
                        <div className="column pr-24">
                            <div className="boxT1">
                                <h4>
                                    New customers
                                    <div className="multiOption">
                                        <div className={openSelect ? "selectBox open": "selectBox"} onClick={()=>{setOpenSelect(prevState => !prevState)}} >
                                            {selected ?
                                                <p className="selected">
                                                    last {selected} months{" "}
                                                    <i className="material-symbols-rounded grey">expand_more</i>
                                                </p>
                                                :
                                                <p className="selected">
                                                    This month{" "}
                                                    <i className="material-symbols-rounded grey">expand_more</i>
                                                </p>
                                            }
                                            <div className="selectDrop">
                                                <ul className="dropMenu">
                                                    <li onClick={()=>{ setSelected(0); getDataForCustomer(0); }} className={selected == 0 ? "selected" : ""}>
                                                        <a href="javascript:void(0);">This month</a>
                                                    </li>
                                                    <li className={selected==3?"selected":""} onClick={()=>{ setSelected(3); getDataForCustomer(3); }}>
                                                        <a href="javascript:void(0);">last 3 months</a>
                                                    </li>
                                                    <li className={selected==6?"selected":""} onClick={()=>{ setSelected(6); getDataForCustomer(6); }}>
                                                        <a href="javascript:void(0);">last 6 months</a>
                                                    </li>
                                                    <li className={selected==12?"selected":""} onClick={()=>{ setSelected(12); getDataForCustomer(12); }}>
                                                        <a href="javascript:void(0);">last 12 months</a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </h4>
                                <div className="recordCount">
                                    {totalCustomer != null ?
                                        <span>{totalCustomer}</span>
                                        :
                                        <span>NA</span>
                                    }
                                    {selected == 0  && <em>+ {percentCustomerChange} this month</em>}
                                </div>
                                <div className="graph mt-24">
                                    {/*Place graph view*/}
                                    <BarGraph label={labelData} customerData={customerData} type="Customers"/>
                                </div>
                            </div>
                        </div>
                        <div className="column">
                            <div className="boxT1">
                                <h4>
                                    Package purchased
                                    <div className="multiOption">
                                        <div className={openSelectSale ? "selectBox open": "selectBox"} onClick={()=>{setOpenSelectSale(prevState => !prevState)}} >
                                            {selectedSale ?
                                                <p className="selected">
                                                    last {selectedSale} months{" "}
                                                    <i className="material-symbols-rounded grey">expand_more</i>
                                                </p>
                                                :
                                                <p className="selected">
                                                    This month{" "}
                                                    <i className="material-symbols-rounded grey">expand_more</i>
                                                </p>
                                            }
                                            <div className="selectDrop">
                                                <ul className="dropMenu">
                                                    {<li onClick={()=>{ setSelectedSale(0); getDataForSales(0); }} className={selectedSale==0?"selected": ""}>
                                                        <a href="javascript:void(0);">This month</a>
                                                    </li>}
                                                    <li className={selectedSale==3?"selected":""} onClick={()=>{ setSelectedSale(3); getDataForSales(3); }}>
                                                        <a href="javascript:void(0);">last 3 months</a>
                                                    </li>
                                                    <li className={selectedSale==6?"selected":""} onClick={()=>{ setSelectedSale(6); getDataForSales(6); }}>
                                                        <a href="javascript:void(0);">last 6 months</a>
                                                    </li>
                                                    <li className={selectedSale==12?"selected":""} onClick={()=>{ setSelectedSale(12); getDataForSales(12); }}>
                                                        <a href="javascript:void(0);">last 12 months</a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </h4>
                                <div className="recordCount">
                                    <span>${totalSales}</span>
                                    
                                    {selectedSale == 0 && <em> +{percentSalesChange?percentSalesChange:0} in this month</em>}
                                </div>
                                <div className="graph mt-24">
                                    <BarGraph label={salesLabelData} customerData={salesData} type="Sales"/>
                                </div>
                            </div>
                        </div>
                        <div className="column pt-24 pr-24">
                            <div className="boxT1">
                                <h3>
                                    Top packages purchased
                                    <span>This month</span>
                                </h3>
                                <div className="graphDeta">
                                    {
                                        packages ?
                                            (
                                                packages.map((item) => {
                                                    return (
                                                        <p>
                                                            {item.package_name ?
                                                                <span>{item.package_name}</span>
                                                                :
                                                                <span>NA</span>
                                                            }
                                                            {item.package_count ?
                                                                <span className="count">{item.package_count}</span>
                                                                :
                                                                <span>NA</span>
                                                            }

                                                        </p>
                                                    )
                                                })
                                            )
                                            :
                                            (
                                                <p>
                                                    No records found
                                                </p>
                                            )
                                    }


                                </div>
                            </div>
                        </div>
                        <CustomerCharing data={chargingData}/>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default DashboardData;





